module.exports = __webpack_public_path__ + "static/img/fancybox_loading@2x.f929386.gif";


/*****************
 ** WEBPACK FOOTER
 ** ./static/fancybox/fancybox_loading@2x.gif
 ** module id = 602
 ** module chunks = 2
 **/